/**
 * Creates the query key for purchasing notes by job ID.
 *
 * @param jobId - The job ID to create the query key for (null if no job context)
 * @returns The query key array that can be used with TanStack Query
 */
export function getPurchasingNoteQueryKey(jobId: number | null) {
  return ["PurchasingNote", jobId] as const;
}
